import React from 'react';
import { ImportantFixData } from '../types';
import { Card, Icon, Tag } from 'antd';
import moment from 'moment';
import { getTagDataForPriority } from '../utils';

type Props = {
    importantFixesData: ImportantFixData[];
    createdAt: string;
    showLinksToIssues?: boolean;
};

export default function ImportantFixesCard({ importantFixesData, createdAt, showLinksToIssues }: Props) {
    return (
        <Card className="report-card to-do-card">
            <div className="card-header">
                <Card.Meta
                    title="Issues to fix"
                    description={`Last found on ${moment(createdAt, 'YYYY-MM-DDTHH:mm:ss').format('MMM DD YYYY, hh:mm A')}`}
                />
            </div>
            <div className="to-do-list-container custom-scrollbar">
                {importantFixesData.map((importantFix) => (
                    <div
                        className="to-do-item"
                        key={importantFix.sectionKey}
                    >
                        <div className="priority">
                            <Tag color={getTagDataForPriority(importantFix.relevance).color}>{getTagDataForPriority(importantFix.relevance).label}</Tag>
                        </div>

                        {showLinksToIssues && (
                            <a
                                className="internal-link"
                                href={`#${importantFix.sectionKey}`}
                            >
                                <Icon type="link" />
                            </a>
                        )}

                        <div dangerouslySetInnerHTML={{ __html: importantFix.recommendation }} />
                    </div>
                ))}
            </div>
        </Card>
    );
}
